
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Denis_classification_of_spinal_fractures',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Denis_classification_of_spinal_fractures.vue